import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthenticationState } from '../store/authentication/authentication.state';

export const authenticationGuardFn: CanActivateChildFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const isAuthenticated = inject(Store).selectSnapshot(
    AuthenticationState.isAuthenticated
  );
  if (isAuthenticated) return true;

  inject(Router).navigate(['/login'], {
    queryParams: { returnUrl: state.url },
  });
  return false;
};
